<template>
    <div>
        <breadcrumb :items="breadcrumbs"></breadcrumb>
        <v-card color="transparent" flat>
            <v-toolbar color="transparent" flat>
                <v-toolbar-title class="font-weight-bold">{{ $t('geneticsAndBreeding.animalsWithExpectedProgenyDifferences')}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="primary" class="mr-2" @click="$router.push({name: 'GeneticSearch'})">{{ $t('geneticsAndBreeding.geneticSearchTool')}}</v-btn>
                <v-menu bottom origin="center center" transition="scale-transition">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" v-bind="attrs" v-on="on">
                            {{ $t("geneticsAndBreeding.dataSubmission") }}
                            <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click="dataSubType=true">
                            <v-list-item-title>
                                {{ $t("geneticsAndBreeding.individualEntry") }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="uploadGenetic()" style="padding: 0">
                            <v-list-item-avatar style="margin: 0px">
                            <!-- <v-icon> mdi-import </v-icon> -->
                            <v-img
                                style="background-size: unset"
                                src="/img/upload_user.svg"
                            ></v-img>
                            </v-list-item-avatar>
                            <v-list-item-title style="font-size: 14px">
                                {{ $t("geneticsAndBreeding.bulkEntry") }}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-toolbar>
            <v-card-text>
                <router-view></router-view>
            </v-card-text>
        </v-card>


        <v-dialog
            v-model="dataSubType"
            persistent
            max-width="750"
        >
        <v-card class="pb-5">
            <v-toolbar flat class="white--text" color="secondary">
                <v-toolbar-title>{{ $t('selectOption') }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="dataSubType=false"><v-icon class="white--text">mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text class="pt-5" style="text-align: center; color: #000">
                {{ $t('geneticsAndBreeding.registerANewAnimalOrSelectAnExistingAnimal') }}
            </v-card-text>
            <v-card-actions  style="text-align: center;display: block;">
                <v-btn
                    color="green darken-1"
                    outlined
                    @click="$router.push({ name: 'AddAnimal' })"
                >
                {{ $t('geneticsAndBreeding.registerNewAnimal') }}
                
                </v-btn>
                <v-btn
                    depressed
                    color="primary"
                    @click="$router.push({ name: 'GeneticsDataSubmissionV1' })"
                >
                {{ $t('geneticsAndBreeding.selectExistingAnimal') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <upload-genetics
      :dialogI="showUploadGenetics"
      @closeUploadGenetics="closeUploadGenetics"
    ></upload-genetics>
    </div>
</template>

<script>
import UploadGenetics from "@/views/genetics/UploadGenetics";

export default {
    mounted(){
        document.title = this.$t('geneticsAndBreeding.geneticsAndBreeding')
    },
    components: {
        UploadGenetics
    },
    data() {
        return {
            dataSubType: false,
            breadcrumbs: [
                {
                    text: this.$t('dashboard'),
                    disabled: false,
                    to: "/",
                },
                {
                    text: this.$t('geneticsAndBreeding.geneticsAndBreeding'),
                    disabled: true,
                    to: { name: "Genetics" },
                },
            ],
            showUploadGenetics: false,
        }
    },
    methods: {
        closeUploadGenetics() {
            this.showUploadGenetics = false;
        },
        uploadGenetic() {
            this.showUploadGenetics = true;
        },
    },
}
</script>